import React, { ReactElement, useRef } from 'react';
import {
  Col, FormGroup, Input, Label, Row,
} from 'idsk-react-components';
import LdapItem from '../../../model/LdapItem';
import SearchLdapDataResult from './SearchLdapDataResult';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import useClickOutsideSearch from '../hook/useClickOutsideSearch';

interface Props {
  searchToken: string;
  setSearchToken: (value: string) => void;
  ldapItem: LdapItem;
  setLdapItem: (item: LdapItem) => void;
  label: string;
  data: LdapItem[];
  isFetched: boolean;
  isPouzivatel?: boolean;
}

const SearchLdapDataComponent = ({
  searchToken,
  setSearchToken,
  ldapItem,
  setLdapItem,
  label,
  data,
  isFetched,
  isPouzivatel,
}: Props): ReactElement => {
  const searchRef = useRef(null);
  const inputRef = useRef(null);
  const { clearFieldErrorMessage, getFieldErrorMessage } = useFieldErrorMessages();
  useClickOutsideSearch({ searchRef, inputRef, setSearchToken });

  const getName = (fullName: string): string => {
    if (fullName === null) {
      return null;
    }
    const start = fullName.indexOf('(');
    const end = fullName.indexOf(')');
    const result = (start > 0 && end > start) ? fullName.substr(start + 1, end - start - 1) : fullName;
    return result.trim();
  };

  return (
    <FormGroup error={!!getFieldErrorMessage(label)}>
      <Row>
        <Col width="one-half">
          <div ref={inputRef}>
            <Label htmlFor={label}>{label}</Label>
            <Input
              id={label}
              error={getFieldErrorMessage(label)}
              type="search"
              name={label}
              onChange={({ target }) => {
                setSearchToken(target.value);
                setLdapItem(null);
              }}
              value={ldapItem ? getName(ldapItem.fullName) : searchToken}
              autoComplete="off"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col width="one-half">
          {isFetched && searchToken && searchToken.trim().length >= 3 && (
            <div ref={searchRef}>
              <SearchLdapDataResult
                searchToken={searchToken}
                data={data}
                isPouzivatel={isPouzivatel}
                setLdapItem={setLdapItem}
                setSearchToken={setSearchToken}
                label={label}
                clearFieldErrorMessage={clearFieldErrorMessage}
              />
            </div>
          )}
        </Col>
      </Row>
    </FormGroup>
  );
};

export default SearchLdapDataComponent;
